// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-item-value .vert-paragraph {
  font-size: var(--font-medium);
  font-weight: 600;
  line-height: var(--font-paragraph-line) !important;
  cursor: auto;
}
.cart-item-value .vert-paragraph.label {
  font-size: var(--font-paragraph);
  font-weight: 400;
  line-height: var(--font-paragraph-line) !important;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Cart/CartItemValueStyles.less"],"names":[],"mappings":"AAAA;EAEQ,6BAAA;EACA,gBAAA;EACA,kDAAA;EACA,YAAA;AAAR;AAEO;EACC,gCAAA;EACA,gBAAA;EACA,kDAAA;AAAR","sourcesContent":[".cart-item-value {\n    .vert-paragraph {\n        font-size: var(--font-medium);\n        font-weight: 600;\n        line-height: var(--font-paragraph-line) !important;\n        cursor: auto;\n\n       &.label {\n        font-size: var(--font-paragraph);\n        font-weight: 400;\n        line-height: var(--font-paragraph-line) !important;\n       }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
